module.exports = __webpack_public_path__ + "static/img/children1.b5233727.jpg";